const env = (key) => {
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
};

export default env;
